module.exports = __webpack_public_path__ + "img/16.c17b4bf4.jpg";